import React from "react";
// import AttestationPanel from "../../shared/dialogs/attestation-panel";
import { PopupApi, PopupResponseTO, PopupTO } from "../auto-popup";
// import { AUTO_POPUP_ACTION_CANCEL, AUTO_POPUP_ACTION_SUBMIT, AUTO_POPUP_TYPE_TEMPLATE } from "../consts";
// import { EnvVariables } from "../context";
import Context from "../context";
import util from "../util";

/*
<AttestationPanel attestationName={popup.template} version={popup.revision}
                onAnswered={(answer) => {
                    const flatten = {};
                    this.__flattenSurveyAnswer(answer, flatten);
                    this.__onSubmit(flatten, onSubmit, onCancel);
                }}
                onClosed={(answer) => {
                    const flatten = {};
                    this.__flattenSurveyAnswer(answer, flatten);
                    let data = null;
                    if (popup.doNotShowAgainKey) {
                        data = {};
                        for (const k in flatten) if (k === popup.doNotShowAgainKey) data[k] = flatten[k];
                    }
                    this.__onCancel(data, onSubmit, onCancel);
                }} />
*/

export const AUTO_POPUP_ACTION_SUBMIT = "submit";
export const AUTO_POPUP_ACTION_CANCEL = "cancel";

export const AUTO_POPUP_TYPE_TEMPLATE = "template";
export const AUTO_POPUP_TYPE_SURVEY = "survey";

export const EnvVariables = {
    //"[USER_NAME]": () => { return Context.; },
    "[APP_ROOT]": () => { return Context.appRoot(); },
}

export class AutoPopupNode {
    constructor(value, next) {
        /** @type {AutoPopupNode} */
        this.next = next;

        /** @type {PopupTO} */
        this.value = value;
    }

    show(path, onSubmit, onCancel) {
        console.log("SHOW");
        const popup = this.value;
        const content = (this.value.type || "").toLocaleLowerCase() === AUTO_POPUP_TYPE_TEMPLATE ?
            <TemplatePopupWrapper popup={this.value}
                onSubmit={(data) => {
                    this.__onSubmit(path, data, onSubmit, onCancel);
                }}
                onCancel={(data) => {
                    this.__onCancel(path, data, onSubmit, onCancel);
                }}>
            </TemplatePopupWrapper> : null;
        Context.message({
            show: true,
            type: "popup",
            size: popup.size,
            message: content,
            title: this.value.title
        });
        // Context.popupNotification().dialog(content, this.value.title ? <h5 tabIndex="0">{this.value.title}</h5> : null, this.value.size);
    }

    __flattenSurveyAnswer(answer, target) {
        for (const k in answer) {
            if (typeof answer[k] !== "object") target[k] = (answer[k] || "").toString();
            else this.__flattenSurveyAnswer(answer[k], target);
        }
    }

    __onSubmit(path, data, onSubmit, onCancel) {
        console.log("SUBMIT");
        const popup = this.value;
        // Context.popupNotification().close();
        Context.message({
            type: "popup",
            show: false
        });

        if (data) {
            const response = this.__createResponse(path, data);
            this.__updateResponse(path, data)
                .then(() => {
                    if (onSubmit) onSubmit(popup, response);
                    this.__openNext(onSubmit, onCancel);
                });
        } else {
            if (onSubmit) onSubmit(popup, null);
            this.__openNext(onSubmit, onCancel);
        }
    }

    __onCancel(path, data, onSubmit, onCancel) {
        console.log("CANCEL");
        const popup = this.value;
        // Context.popupNotification().close();
        Context.message({
            type: "popup",
            show: false
        });

        if (data) {
            const response = this.__createResponse(path, data);
            this.__updateResponse(path, data)
                .then(() => {
                    if (onCancel) onCancel(popup, response);
                    this.__openNext(onSubmit, onCancel);
                });
        } else {
            if (onCancel) onCancel(popup, null);
            this.__openNext(onSubmit, onCancel);
        }
    }

    __createResponse(path, data) {
        const response = new PopupResponseTO();
        response.path = path;
        response.popupName = this.value.name;
        response.revision = this.value.revision;
        response.data = data;
        return response;
    }

    __updateResponse(path, data) {
        const response = new PopupResponseTO();
        response.path = path;
        response.popupName = this.value.name;
        response.revision = this.value.revision;
        response.data = data;

        const api = new PopupApi();

        return api.updateResponseAsync(response)
    }

    __openNext(onSubmit, onCancel) {
        console.log("NEXT");
        if (this.next) this.next.show(onSubmit, onCancel);
    }
}

export class TemplatePopupWrapper extends React.Component {
    constructor(props) {
        super(props);
        /** @type {import("react").RefObject<HTMLDivElement>} */
        this.divRef = React.createRef(null);
    }

    componentDidMount() {
        if (this.divRef.current) {
            const $div = $(this.divRef.current);
            if ($div.children().length === 0) {
                this.__prepareHtml();
                $div.append(this.content);
            }
        }
    }

    __prepareHtml() {
        /** @type {PopupTO} */
        const popup = this.props.popup;
        const holderMap = {};
        for (const k in EnvVariables) holderMap[k] = EnvVariables[k]();

        popup.template = util.populate(popup.template, holderMap);

        let $el = $(`<div>${popup.template}</div>`);
        let $form = $el.find("form");
        if ($form.length === 0) {
            $el = $(`<form>${popup.template}</form>`);
            $form = $el;
        }

        this.__setUpForm($form);

        const placeHolders = $el.find("span.text-placeholder");
        for (let i = 0; i < placeHolders.length; i++) {
            const $holder = $(placeHolders[i]);
            const key = $holder.data("key");

            if (key) {
                const f = EnvVariables[key];
                $holder.text(f ? f() : "");
            }
        }

        this.content = $el;
    }

    __setUpButtons(/** @type {JQuery<any>} */$form) {
        const $buttons = $form.find("button, input[type=button], input[type=submit]");
        $buttons.click((evt) => {
            const $clicked = $(evt.target);
            const action = $clicked.data("popup-action");

            switch (action) {
                case AUTO_POPUP_ACTION_SUBMIT:
                    this.__onSubmit($form);
                    break;
                case AUTO_POPUP_ACTION_CANCEL:
                    this.__onCancel($form);
                    break;
            }
        });
    }

    __onSubmit(/** @type {JQuery<any>} */$form) {
        const array = $form.serializeArray();
        var data = {};
        array.forEach(item => { data[item.name] = item.value; });
        if (this.props.onSubmit) this.props.onSubmit(data);
    }

    __onCancel(/** @type {JQuery<any>} */$form) {
        /** @type {PopupTO} */
        const popup = this.props.popup;
        // Context.popupNotification().close();
        Context.message({
            type: "popup",
            show: false
        });

        let data = null;
        if (popup.doNotShowAgainKey) {
            data = {};
            const array = $form.serializeArray();
            array.forEach(item => { if (item.name === popup.doNotShowAgainKey) data[item.name] = item.value; });
        }
        if (this.props.onCancel) this.props.onCancel(data);
    }

    __setUpForm(/** @type {JQuery<any>} */$form) {
        console.log("setup FORM");
        $form.on("submit", (evt) => {
            evt.preventDefault();
            console.log("form submmit");
            return false;
        });

        this.__setUpButtons($form);
    }

    render() {
        return <div tabIndex="0" ref={this.divRef}></div>
    }
}